/**
 * sl-67kc.3.3: Shared row-level primitives for the history-row-variants
 * system (`history-row-variants/`). Extracted so each variant can
 * render identical label/value rows + error boxes without duplicating
 * the theme-aware styling.
 *
 * SOLID:
 * - S: Each primitive owns one visual concern.
 * - D: Colours come from theme tokens in `history-panel.css`; no variant
 *      has to thread theme info down.
 */
import clsx from 'clsx';
import type { FC, ReactNode } from 'react';

import * as styles from '../history-panel.css';

export const ErrorBox: FC<{ message: string; size?: 'small' | 'medium' }> = ({
  message,
  size = 'medium',
}) => (
  <div className={styles.errorBox[size]} role="alert">
    {message}
  </div>
);

export const DataRow: FC<{
  label: string;
  value: ReactNode;
  tone?: styles.HistoryTone;
}> = ({ label, value, tone }) => (
  <div className={styles.dataRow}>
    <span className={styles.dataLabel}>{label}</span>
    <span
      className={clsx(styles.dataValue, tone && styles.dataValueTone[tone])}
    >
      {value}
    </span>
  </div>
);
